import React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { ChevronRight } from '../icons';
import CmsLinks from '../ui/CmsLinks';
import { WPLink } from '@/data/wp/operations/queries/fragments/link';
import styled from '@mui/system/styled';
import Grid from '@mui/material/Grid';
import MuiTypography from '@mui/material/Typography';

interface BreadcrumbProps {
  breadcrumbs: {
    links: WPLink[];
  }[];
}

const StyledBreadcrumbs = styled(Breadcrumbs)({
  '.MuiBreadcrumbs-separator': {
    'svg': {
      width: '10px',
      height: '10px',
    }
  }
});

const StyledCmsLinks = styled(CmsLinks)({
  '.MuiLink-root': {
    color: '#545454',
    fontSize: '12px',
    letterSpacing: '-0.16px',
    lineHeight: '24px',
    textDecoration: 'unset'
  }
});

const LastSectionText = styled(MuiTypography)({
  color: '#545454',
  fontSize: '12px',
  letterSpacing: '-0.16px',
  lineHeight: '24px',
});

const isUrlEmpty = (link: WPLink | undefined): boolean => {
  if (!link) return true;

  const hasValidUrl = link.url && link.url.trim().length > 0;
  const hasValidInternalUrl = link.linkInterno?.uri && link.linkInterno.uri.trim().length > 0;

  return !hasValidUrl && !hasValidInternalUrl;
};

const Breadcrumb: React.FC<BreadcrumbProps> = ({ breadcrumbs}) => {
  return <Grid item xs={12} sx={{ marginBottom: '21px' }}>
    <StyledBreadcrumbs
        separator={<ChevronRight />}
        aria-label="breadcrumb"
      >
        {breadcrumbs && breadcrumbs.length > 0 && breadcrumbs.map((singleBreadcrumb, index) => {
          /* Caso senza link per l'ultimo breadcrumb (es per famiglie in PLP) */
          if (singleBreadcrumb.links.length > 0 && isUrlEmpty(singleBreadcrumb.links[0])) {
            const link = singleBreadcrumb.links[0];
            return (
              <LastSectionText key={index}>
                {link.label || link.linkInterno?.title || ''}
              </LastSectionText>
            );
          }
          return <StyledCmsLinks key={index} data={singleBreadcrumb.links} direction="row"></StyledCmsLinks>;
        })}
      </StyledBreadcrumbs>
  </Grid>
}

export default Breadcrumb;
